import { nncMenu } from './nnc.menu';

export const modulesMenus: Record<
  string,
  import('../menu.utils').MenuItemInput[]
> = {
  nnc: nncMenu,
  //   oee: oeeMenu,
};
